module.exports = __webpack_public_path__ + "static/img/new13-Cn7Yt2Rq.a1b83af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new13-Cn7Yt2Rq.png
// module id = ysHQ
// module chunks = 16